<template>
    <div>
        <TheHeader class="pc-header" />
        <BaseTitle class="dsf" :infor="infor" />
        <div class="address">
            <div class="address-inner">
                <img class="address-ma" src="@/assets/images/contact_ma.png">
                <BaseAddress class="contactus-address" />
            </div>
        </div>
        <BaseTitleCenter class="contact-map-title" :title="infor.bottomTitle" />
        <div class="baidu-map" id="contactBDMap"></div>
        <TheFooter class="pc-the-footer-other" />
    </div>
</template>
<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'

    import BaseTitle from '@/components/module/BaseTitle'
    import BaseTitleCenter from '@/components/module/BaseTitleCenter'
    import BaseAddress from '@/components/module/BaseAddress'

    import '@/assets/less/module/module-base-address_contactus-address.less'

    export default {
        name: 'PCContactUs',
        props: {
            infor: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseAddress,
            BaseTitleCenter
        },
        mounted() {
            this.$parent.getBDMap();
        }
    }
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-box {
    padding-top: 50px;
    padding-bottom: 30px;
}
/*导航*/
.address {
    width: 100%;
    height: 560px;
    background: #F0F4F6;
}
.address-inner {
    padding-top: 192px;
    width: 740px;
    margin: 0 auto;
    height: 176px;
}
.address-ma {
    float: left;
    width: 176px;
    height: 176px;
}
.title-h3 {
    padding: 50px 0 30px;
    font-size: 38px;
    height: 53px;
    line-height: 53px;
    text-align: center;
    font-weight: normal;
}

.baidu-map {
    max-width: 1200px;
    margin: 0 auto 30px;
    height: 390px;
    background: #F0F4F6;
}

.contact-map-title {
    padding: 50px 0 30px;
}

</style>